import { createSlice } from '@reduxjs/toolkit';
import { fetchStats } from '../thunks/analytics';

const initialState = {
  stats: {},
  fetching: false,
  fetchError: '',
};

export const analyticsSlice = createSlice({
  name: 'analytics',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchStats.pending]: (state) => {
      state.saving = true;
    },
    [fetchStats.fulfilled]: (state, action) => {
      state.saving = false;
      state.stats = action.payload;
    },
    [fetchStats.rejected]: (state) => {
      state.saving = false;
    },
  },
});
